export default {"src":"/_next/static/media/clean.c7cb9b6f.svg","height":25,"width":25};